import React, { useState } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { Col, Row } from '../../components/layout';
import { SelectInput, TextInput } from '../../components/input';
import SearchIcon from '../../assets/icons/search.svg';
import { getLeagues, mobileBreakpoint } from '../../lib';
import PlusIcon from '../../assets/icons/plus.svg';
import MinusIcon from '../../assets/icons/minus.svg';

const positionsOptions = [
    {label: 'All Positions', value: ''},

    {label: 'C', value: 'C'},
/*    {label: 'C/LW', value: 'C/LW'},
    {label: 'C/RW', value: 'C/RW'},
    {label: 'C/W', value: 'C/W'},*/

    {label: 'D', value: 'D'},
    {label: 'G', value: 'G'},

    {label: 'LW', value: 'LW'},
/*    {label: 'LW/C', value: 'LW/C'},
    {label: 'LW/RW', value: 'LW/RW'},*/

    {label: 'RW', value: 'RW'},
/*    {label: 'RW/C', value: 'RW/C'},
    {label: 'RW/LW', value: 'RW/LW'},*/

//    {label: 'W/C', value: 'W/C'},
];

const leaguesOptions = [
    {label: 'All Leagues', value: ''},
    ...getLeagues().map((league) => ({label: league, value: league}))
];

const availabillityOptions = [
    {label: 'Show Available', value: 'Available'},
    {label: 'Show All', value: 'All'},
];

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
`

const FilterExpandIcon = styled.img.attrs(props => ({
    src: props.src
  }))`
    cursor: pointer;
`;

function PlayerFilters({ filtersState, setFilter }){
    const isMobile = useMediaQuery({ maxWidth: mobileBreakpoint });
    const [ isExpanded, setIsExpanded ] = useState(false);
    return (
    <>
        {isMobile &&
            <Row justifyContent="space-between" alignItems="center" margin="0 17px 0 0">
                <Col>
                    <h3>Filter</h3>
                </Col>
                <Col>
                    <IconContainer>
                        <FilterExpandIcon src={isExpanded ? MinusIcon : PlusIcon} isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)} />
                    </IconContainer>
                </Col>
            </Row>
        }
        {(!isMobile || isExpanded) && <Row margin="0 0 24px 0" flexDirection={isMobile ? 'column' : 'row'}>
            <SelectInput
                width={isMobile ? '100%' : '19%'}
                margin="0 20px 0 0"
                value={filtersState['positions']}
                onChange={(e) => setFilter(e.target.value, 'positions')}
                options={positionsOptions}
                inputPadding="0 20px 0 0"
            />
            <SelectInput
                width={isMobile ? '100%' : '19%'}
                margin="0 20px 0 0"
                value={filtersState['leagues']}
                onChange={(e) => setFilter(e.target.value, 'leagues')}
                options={leaguesOptions}
                inputPadding="0 20px 0 0"
            />
            <SelectInput
                width={isMobile ? '100%' : '22%'}
                margin="0 20px 0 0"
                value={filtersState['availability']}
                onChange={(e) => setFilter(e.target.value, 'availability')}
                options={availabillityOptions}
                inputPadding="0 20px 0 0"
            />
            <TextInput
                width={isMobile ? '100%' : '40%'}
                margin="0 20px 0 0"
                value={filtersState['search']}
                onChange={(e) => setFilter(e.target.value, 'search')}
                inputPadding="0 20px 0 0"
                placeholder="Search by player name"
                icon={SearchIcon}
            />
        </Row>}
    </>
    )
}

export default PlayerFilters;